import { ChevronRight, Globe, type LucideIcon } from "lucide-react";

interface ActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  icon?: LucideIcon;
}

export const ActionButton = ({ children, onClick, icon: Icon = Globe }: ActionButtonProps) => {
  return (
    <button className="btn btn-secondary" onClick={onClick}>
      <Icon className="btn-secondary-icon" strokeWidth={1.8} />
      <span>{children}</span>
      <ChevronRight className="btn-secondary-chevron" strokeWidth={2.5} />
    </button>
  );
};
